import React from 'react';
import { FormInputTextarea } from '../../../common/formInputs/FormInputTextarea';
import { positiveOrNegative } from '../../../common/constants';
import { FormInputSelect } from '../../../common/formInputs/FormInputSelect';

function CompanyComentaries({
  errors, isValid, register, answers,
}) {
  return (
    <>
      <h4 className="text-center mt-3">Commenti Aziendali Commerciali</h4>

      <div className="row mt-5">
        {answers.company_commentaries.map((commentary, index) => (
          <div className="col-12 col-md-6 mb-4" key={index}>
            <div className="card border">
              <div className="card-body px-5">
                <FormInputTextarea
                  placeholder="Testo del Commento"
                  label="Testo del Commento"
                  error={errors.commentary_text?.message}
                  valid={isValid(`company_commentaries.${index}.commentary_text`)}
                  registration={register(`company_commentaries.${index}.commentary_text`)}
                />
                <FormInputSelect
                  label="Positivo o Negativo"
                  placeholder="-Seleziona-"
                  options={positiveOrNegative}
                  error={errors.positive_or_negative?.message}
                  valid={isValid(`company_commentaries.${index}.positive_or_negative`)}
                  value={commentary.positive_or_negative}
                  registration={register(`company_commentaries.${index}.positive_or_negative`)}
                  customStyle={`text-white ${commentary.positive_or_negative == 'Neutral' ? 'bg-warning' : (commentary.positive_or_negative === 'Positive' ? 'bg-success' : 'bg-danger')}`}
                />

              </div>
            </div>
          </div>
        ))}

      </div>
    </>
  );
}

export default CompanyComentaries;
